import { gsap } from "gsap";

const Ticker = () => {
	const block = document.querySelectorAll(".ticker");
	if (!block) {
		return;
	}
	block.forEach((el) => {
		const reverse = el.classList.contains("ticker_reverse");
    const duration = el.getAttribute("data-duration");
		const list = el.querySelector(".ticker__list");
		const row = el.querySelector(".ticker__row");
		list.append(row.cloneNode(true));
		const tl = gsap.timeline();

		tl.to(list, {
			x: reverse ? row.offsetWidth : -row.offsetWidth,
			repeat: -1,
			duration: parseInt(duration),
			ease: "none"
		});

		el.addEventListener("ticker-pause", (e) => {
			tl.pause();
		});

		el.addEventListener("ticker-play", (e) => {
			tl.play();
		});
	});
};

export default Ticker;
